<template>
  <div class="commodity-scale-wrapper">
    <div class="commodity">
      <div class="filter-wrapper">
        <CommonFilterBar
          :initialValues="initialValues"
          :fields="filterFields"
          @search="onSearch"
          @export="onExport"
        />
      </div>
      <div class="card-wrapper" v-loading="cardLoading">
        <CommodityDataCard
          :list="cardData"
          :name="`较上${dateType[initialValues.timeUnit]}`"
        />
      </div>
      <div class="sales-volume">
        <div class="product-sales-volume" v-loading="productLoading">
          <div class="title">产品销量</div>
          <BarChart
            class="bar-chart-panel"
            :chartData="productBarData"
            :displayCount="8"
            showLegend
            :xAxisLabelMaxLength="7"
          />
        </div>
        <div class="channel-sales-volume" v-loading="channelLoading">
          <div class="title">渠道销量</div>
          <BarChart
            class="bar-chart-panel"
            :chartData="channelBarData"
            :displayCount="8"
            showLegend
          />
        </div>
      </div>
      <div class="rank-wrapper" v-loading="tableLoading">
        <div class="title">{{ initialValues.showDate }}商品业绩对比表</div>
        <DataTable
          :tableData="performanceTableData"
          :column="performanceColumn"
        ></DataTable>
      </div>
    </div>
  </div>
</template>

<script>
import CommonFilterBar from "../components/common-filter-bar.vue";
import CommodityDataCard from "../components/commodity-data-card.vue";
import BarChart from "../components/bar-chart.vue";
import DataTable from "../components/data-table.vue";
import {
  orderCount,
  orderCountDirectAndAgentSale,
  BiServiceUserList,
  BiSourecList,
  commoditySale,
  channelSale,
  serviceUserSale,
  orderBoardExportMultiSimple,
} from "@/common/api";

const CARD_CONFIG = [
  {
    title: "营收总额",
    key: "salesTotalAmountExTax",
    compareKey: "salesTotalAmountExTaxCompare",
    icon: "actuallyPriceSum-icon.png",
    shadowColor: "#693EC566",
  },
  {
    title: "销售金额（不含税）",
    key: "salesAmountExTax",
    compareKey: "salesAmountExTaxCompare",
    icon: "salesAmountExcludingTax-icon.png",
    shadowColor: "#3C4EC866",
  },
  {
    title: "兑换金额（不含税）",
    key: "exchangeAmountExTax",
    compareKey: "exchangeAmountExTaxCompare",
    icon: "exchangeAmountExcludingTax-icon.png",
    shadowColor: "#C35D3B66",
  },
  {
    title: "销售单数",
    key: "salesOrderCount",
    compareKey: "salesOrderCountCompare",
    icon: "salesVolumeExcludingTax-icon.png",
    shadowColor: "#9B414166",
  },
  {
    title: "兑换单数",
    key: "exchangeOrderCount",
    compareKey: "exchangeOrderCountCompare",
    icon: "exchangeRate-icon.png",
    shadowColor: "#116F6166",
  },
  {
    title: "购买人数",
    key: "buyerCount",
    compareKey: "buyerCountCompare",
    icon: "numberPurchasers-icon.png",
    shadowColor: "#36778B66",
  },
  {
    title: "兑换人数",
    key: "exchangeUserCount",
    compareKey: "exchangeUserCountCompare",
    icon: "numberExchangeParticipants-icon.png",
    shadowColor: "#975B4766",
  },

  {
    title: "直客金额",
    key: "directSaleAmount",
    compareKey: "directSaleAmountCompare",
    icon: "directSaleAmount-icon.png",
    shadowColor: "#A1762366",
  },
  {
    title: "直客单数",
    key: "directOrderCount",
    compareKey: "directOrderCountCompare",
    icon: "directOrderCount-icon.png",
    shadowColor: "#00804A66",
  },
  {
    title: "代理金额",
    key: "agentSaleAmount",
    compareKey: "agentSaleAmountCompare",
    icon: "agentSaleAmount-icon.png",
    shadowColor: "#3C4EC866",
  },
  {
    title: "代理单数",
    key: "agentOrderCount",
    compareKey: "agentOrderCountCompare",
    icon: "agentOrderCount-icon.png",
    shadowColor: "#693EC566",
  },
];

export default {
  name: "board",
  components: { CommonFilterBar, CommodityDataCard, BarChart, DataTable },
  data() {
    return {
      filterFields: [
        { label: "客户归属：", prop: "owner", type: "select", options: [] },
        { label: "来源渠道：", prop: "channel", type: "select", options: [] },
      ],
      dateType: {
        day: "日",
        week: "周",
        month: "月",
        year: "年",
        diy: "段",
      },
      cardLoading: false,
      productLoading: false,
      channelLoading: false,
      tableLoading: false,
      initialValues: {
        timeUnit: "month", // 时间类型
        owner: "", //管家
        channel: "", //渠道
        date: new Date(), // 初始时间
        startTime: "", //开始时间
        endTime: "", //结束时间
        showDate: "", //显示的时间
      },
      cardData: CARD_CONFIG.map((item) => ({
        title: item.title,
        value: item.key.includes("Amount") ? "00" : "00",
        icon: item.icon,
        isUp: item.key !== "buyerCount",
        compareValue: "+0.00",
        shadowColor: item.shadowColor,
      })),
      productBarData: {
        categories: [],
        series: [],
      },
      channelBarData: {
        categories: [],
        series: [
          {
            name: "购买数",
            color: ["#70A4F8", "#3B7BDF"],
            data: [],
          },
        ],
      },
      performanceTableData: [
        {
          serviceUserName: "钱钱",
          exchangeQuantity: 1,
          exchangeUserCount: 2,
          exchangeAmount: 3,
          purchaseQuantity: 4,
          purchaseUserCount: "234",
          purchaseAmount: "1,064,859,671",
          repurchaseQuantity: "321",
          repurchaseUserCount: "234",
          repurchaseAmount: "1,064,859,671",
        },
      ],
      performanceColumn: [
        {
          prop: "serviceUserName",
          label: "客户归属",
        },
        {
          prop: "exchangeQuantity",
          label: "兑换数量",
        },
        {
          prop: "exchangeUserCount",
          label: "兑换人数",
        },
        {
          prop: "exchangeAmount",
          label: "兑换金额",
        },
        {
          prop: "purchaseQuantity",
          label: "购买数量",
        },
        {
          prop: "purchaseUserCount",
          label: "购买人数",
        },
        {
          prop: "purchaseAmount",
          label: "购买金额",
        },
        {
          prop: "repurchaseQuantity",
          label: "复购数量",
        },
        {
          prop: "repurchaseUserCount",
          label: "复购人数",
        },
        {
          prop: "repurchaseAmount",
          label: "复购金额",
        },
      ],
    };
  },
  computed: {
    queryParams() {
      const {
        startTime,
        endTime,
        timeUnit: typeEnum,
        owner: serviceUserId,
        channel: sourceCode,
      } = this.initialValues;
      return {
        startTime, // 开始时间
        endTime, // 结束时间
        typeEnum: typeEnum ? typeEnum.toUpperCase() : "", // 时间类型
        ...(serviceUserId !== "" && { serviceUserId }),
        ...(sourceCode !== "" && { sourceCode }),
      };
    },
  },
  mounted() {
    this.getFilterItem();
  },
  methods: {
    // 顶部卡片
    async getcardData() {
      this.cardLoading = true;
      try {
        const [res, res2] = await Promise.all([
          orderCount(this.queryParams),
          orderCountDirectAndAgentSale(this.queryParams),
        ]);
        if (res.code == 0 && res2.code == 0) {
          const d = { ...res.data, ...res2.data };
          this.cardData = CARD_CONFIG.map((item) => ({
            title: item.title,
            value: d[item.key],
            icon: item.icon,
            compareValue: d[item.compareKey],
            isUp: Number(d[item.compareKey]) >= 0,
            shadowColor: item.shadowColor,
          }));
        } else {
          const errMsg =
            (res.code !== 0 ? res.msg : "") ||
            (res2.code !== 0 ? res2.msg : "") ||
            "获取指标卡片数据失败";
          this.$message.error(errMsg);
        }
      } catch (error) {
        console.error(error);
        this.$message.error("获取指标卡片数据失败，请联系管理员或稍后重试");
      } finally {
        this.cardLoading = false;
      }
    },
    // 产品销量
    async getcommoditySale() {
      this.productLoading = true;
      try {
        const res = await commoditySale(this.queryParams);
        if (res.code == 0) {
          const list = res.data || [];
          const seriesConfig = [
            {
              name: "购买数",
              color: ["#70A4F8", "#3B7BDF"],
              key: "totalSaleQuantity",
            },
            {
              name: "兑换数",
              color: ["#A091F8", "#7E6BEE"],
              key: "exchangeQuantity",
            },
            {
              name: "复购数",
              color: ["#D0E3FF", "#A3C2F9"],
              key: "repurchaseCount",
            },
          ];
          this.productBarData = {
            categories: list.map((item) => item.commodityName),
            series: seriesConfig.map(({ name, color, key }) => ({
              name,
              color,
              data: list.map((item) => item[key]),
            })),
          };
        } else {
          this.$message.error(res.msg || "获取产品销量数据失败");
        }
      } catch (error) {
        console.error(error);
        this.$message.error("获取产品销量数据失败，请稍后重试");
      } finally {
        this.productLoading = false;
      }
    },
    // 渠道销量
    async getChannelSale() {
      this.channelLoading = true;
      try {
        const res = await channelSale(this.queryParams);
        if (res.code == 0) {
          const list = res.data || [];
          const seriesConfig = [
            {
              name: "购买数",
              color: ["#70A4F8", "#3B7BDF"],
              key: "purchaseQuantity",
            },
            {
              name: "兑换数",
              color: ["#4EE2A9", "#00C4A3"],
              key: "exchangeQuantity",
            },
            {
              name: "复购数",
              color: ["#FFC299", "#FFA066"],
              key: "repurchaseCount",
            },
          ];
          this.channelBarData = {
            categories: list.map((v) => v.sourceName),
            series: seriesConfig.map(({ name, color, key }) => ({
              name,
              color,
              data: list.map((v) => v[key]),
            })),
          };
        } else {
          this.$message.error(res.msg || "获取渠道销量数据失败");
        }
      } catch (error) {
        console.error(error);
        this.$message.error("获取渠道销量数据失败，请稍后重试");
      } finally {
        this.channelLoading = false;
      }
    },
    // 商品业绩对比表
    async getServiceUserSale() {
      this.tableLoading = true;
      try {
        const res = await serviceUserSale(this.queryParams);
        if (res.code == 0) {
          this.performanceTableData = res.data || [];
        } else {
          this.$message.error(res.msg || "获取商品业绩对比数据失败");
        }
      } catch (error) {
        console.error(error);
        this.$message.error("获取商品业绩对比数据失败，请稍后重试");
      } finally {
        this.tableLoading = false;
      }
    },
    async getFilterItem() {
      try {
        const res1 = await BiServiceUserList();
        const res2 = await BiSourecList({
          pageNo: 1,
          pageSize: 99999,
        });
        if (res1.code == 0 && res2.code == 0) {
          this.filterFields[0].options = res1.data.map((item) => ({
            value: item.serviceUserId,
            label: item.serviceUserName,
          }));
          this.filterFields[1].options = res2.data.records.map((item) => ({
            value: item.sourceCode,
            label: item.sourceName,
          }));
        } else {
          const errMsg =
            (res1.code !== 0 ? res1.msg : "") ||
            (res2.code !== 0 ? res2.msg : "") ||
            "获取筛选条件失败";
          this.$message.error(errMsg);
        }
      } catch (error) {
        console.error(error);
        this.$message.error("获取筛选条件失败，请稍后重试");
      }
    },
    onSearch(e) {
      this.initialValues = e;
      this.getcardData();
      this.getcommoditySale();
      this.getChannelSale();
      this.getServiceUserSale();
      // console.log(this.initialValues)
    },
    async onExport(e) {
      try {
        const res = await orderBoardExportMultiSimple(this.queryParams);

        // 从 headers 中提取文件名，如果获取不到则使用默认的文件名
        // const disposition = res.headers && res.headers['content-disposition']
        // let fileName = '服务看板导出数据.xlsx'
        // if (disposition) {
        //   const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        //   const matches = filenameRegex.exec(disposition)
        //   if (matches && matches[1]) {
        //     fileName = decodeURIComponent(matches[1].replace(/['"]/g, ''))
        //   }
        // }

        // 创建 Blob 并下载
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = "商品看板导出数据.xlsx";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(downloadUrl);
      } catch (error) {
        console.error(error);
        this.$message.error("导出失败");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.commodity-scale-wrapper {
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  background-color: #f5f7fa;
}

.commodity {
  width: 100%;
  background-color: #f5f7fa;
  min-height: 100vh;
  box-sizing: border-box;

  .title {
    font-weight: 500;
    font-size: 20px;
    color: #000000;
    line-height: 33px;
    margin-bottom: 20px;
  }

  .filter-wrapper {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 20px;
  }

  .card-wrapper {
    width: 100%;
    min-width: 0;
  }

  .sales-volume {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 24px;
    margin-top: 24px;

    .product-sales-volume {
      min-width: 0;
      height: 400px;
      background: #fff;
      padding: 24px 38px 38px 38px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
    }

    .channel-sales-volume {
      min-width: 0;
      height: 400px;
      background: #fff;
      padding: 24px 38px 38px 38px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
    }

    .bar-chart-panel {
      flex: 1;
      min-height: 0;
    }
  }

  .rank-wrapper {
    background: #fff;
    margin-top: 24px;
    padding: 24px 38px 38px 38px;
    box-sizing: border-box;
    height: 529px;
    display: flex;
    flex-direction: column;
    min-width: 0;
    overflow: hidden;

    ::v-deep .data-table {
      flex: 1;
      min-height: 0;
      height: auto !important;
      overflow: hidden;
      width: 100%;
    }
  }
}

@media (max-width: 1024px) {
  .commodity {
    .sales-volume {
      grid-template-columns: 1fr;
    }
  }
}
</style>
